import { ref } from 'vue';

export const visible = ref(false); // 메뉴 표시 여부
export const position = ref({ x: 0, y: 0 }); // 메뉴 위치
export const menuItems = ref([]); // 메뉴 항목들

// 메뉴 열기 함수
export function openMenu(event, items) {
  if (event && event.preventDefault) {
    event.preventDefault(); // 마우스 이벤트가 있을 경우에만 preventDefault 호출
  }
  items = items.filter(item => item);
  const screenWidth = window.innerWidth;
  const screenHeight = window.innerHeight;

  // 임시로 메뉴 요소를 생성하여 크기 계산
  const menuElement = document.createElement('div');
  menuElement.style.position = 'absolute';
  menuElement.style.visibility = 'hidden';
  menuElement.style.display = 'block';
  menuElement.style.padding = '10px';
  menuElement.style.background = 'white';
  menuElement.style.border = '1px solid #ccc';
  menuElement.innerHTML = items.map(item => `<div>${item.label}</div>`).join('');

  // 메뉴를 문서에 추가하여 크기를 측정한 후 삭제
  document.body.appendChild(menuElement);
  const menuRect = menuElement.getBoundingClientRect();
  document.body.removeChild(menuElement);

  const menuWidth = menuRect.width * 1.1;
  const menuHeight = menuRect.height * 1.6;

  const menuPositionX = event.clientX;
  const menuPositionY = event.clientY;

  // X 값 조정: 메뉴가 화면을 벗어나지 않도록
  const adjustedX = menuPositionX + menuWidth > screenWidth ? screenWidth - menuWidth : menuPositionX;

  // Y 값 조정: 메뉴가 화면을 벗어나지 않도록
  const adjustedY = menuPositionY + menuHeight > screenHeight ? screenHeight - menuHeight : menuPositionY;

  visible.value = true;
  position.value = { x: adjustedX, y: adjustedY };
  menuItems.value = items;
}

// 메뉴 닫기 함수
export function closeMenu() {
  visible.value = false;
}

// 외부 클릭으로 메뉴 닫기
document.addEventListener('click', closeMenu);
